import React, { useEffect, useState } from 'react';
import { Grid, CardHeader, Typography, Fade } from '@material-ui/core';
import { Button as Couponbutton } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import Controls from '../components/controls/Controls';
import { Form, useForm } from '../components/controls/useForm';
import { makeStyles } from "@material-ui/core/styles";
import { displayRazorpay, addAffinityUserDetails, dobConversion, calculateAge } from "../helpers/razorpay";
import { addUser } from "../helpers/addUserWithotPayment";
import { initializeCleverTap, pushEventToCleverTap, pushProfileToCleverTap } from '../utils/clevertap';
import useDataStore from '../store/dataStore';
import "../assets/css/muthoot-form.css";
import { getFieldKey, getActiveConditionalRule } from '../helpers/helperFunctions';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ValidateMembershipComponent from './ValidateMembershipComponent';

const genderItems = [
    { id: 'Male', title: 'Male' },
    { id: 'Female', title: 'Female' }
];

const defaultMemberFormConfig = [
    { value: 'name', label: 'Full Name', isOptional: false },
    { value: 'email', label: 'Email ID', isOptional: false, pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$' },
    { value: 'mobile', label: 'Mobile Number', isOptional: false, pattern: '^[0-9]{10}$', maxLength: 10 },
    { value: 'relationship', label: 'Relationship', isOptional: true, type: 'select', options: ['Spouse', 'Son', 'Daughter', 'Father', 'Mother', 'Sibling', 'Other'] },
    { value: 'gender', label: 'Gender', isOptional: true, type: 'radio', options: ['Male', 'Female', 'Other'] },
    { value: 'dob', label: 'Date Of Birth', isOptional: true, type: 'date' }
];

const getMemberFormConfig = (selectedPackage) => selectedPackage.memberForm || defaultMemberFormConfig;

const buildInitialValues = (formConfig, memberCount = 0, memberFormConfig = []) => {
    const vals = { id: 0 };
    if (!formConfig) return vals;
    formConfig.forEach(field => {
        const key = getFieldKey(field);
        if (field.type === 'date') {
            vals[key] = null;
        } else if (field.type === 'radio') {
            vals[key] = field.options && field.options.length > 0 ? field.options[0] : '';
        } else if (field.type === 'select') {
            vals[key] = '';
        } else {
            vals[key] = '';
        }
    });
    for (let i = 2; i <= memberCount; i++) {
        memberFormConfig.forEach(field => {
            const key = `member_${getFieldKey(field)}${i}`;
            if (field.type === 'date') {
                vals[key] = null;
            } else if (field.type === 'radio') {
                vals[key] = field.options && field.options.length > 0 ? field.options[0] : '';
            } else {
                vals[key] = '';
            }
        });
    }
    return vals;
};

function getMembers(selectedPackage, id) {
    if (!selectedPackage.complexStructure)
        return selectedPackage.members || 0;
    if (!Array.isArray(selectedPackage.structure)) return 0;
    var found = selectedPackage.structure.filter(function (item) { return item.subId + '' === id; });
    return found[0] ? found[0].members : 0;
}

function getPrice(selectedPackage, id) {
    if (selectedPackage.discountPercent)
        return 0;
    if (!selectedPackage.complexStructure)
        return (selectedPackage.priceWithGST ? selectedPackage.priceWithGST : selectedPackage.price) || 0;
    if (!Array.isArray(selectedPackage.structure)) return 0;
    var found = selectedPackage.structure.filter(function (item) { return item.subId + '' === id; });
    return found[0] ? found[0].price : 0;
}

function getMetaData(packageform, values) {
    const metadata = {};
    const metadataFields = (packageform.form || []).filter(item => item.isMeta).map(metaField => getFieldKey(metaField));
    metadataFields.reduce((prev, curr) => metadata[curr] = values[curr], metadata);
    return Object.keys(metadata).length > 0 ? metadata : null;
}

const buildFormPages = (selectedPackage, members, showAdditionalMemberDetails) => {
    if (Array.isArray(selectedPackage.formPages) && selectedPackage.formPages.length > 0) {
        return selectedPackage.formPages.filter(page => {
            const sections = page.sections || [];
            const hasMembers = sections.includes('members');
            if (hasMembers && (!showAdditionalMemberDetails || members <= 1)) return false;
            return true;
        });
    }
    if (showAdditionalMemberDetails && members > 1) {
        return [
            { sections: ['personal', 'address', 'coupon'], title: 'Your Details' },
            { sections: ['members'], title: 'Additional Members' }
        ];
    }
    return [
        { sections: ['personal', 'address', 'coupon'], title: 'Your Details' }
    ];
};

const useStyles = makeStyles({
    root: {
        'padding-top': '25px',
        borderRadius: '15px',
        boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.16)',
        backgroundColor: '#fff',
        fontFamily: 'Nunito',
        "& h7": {
            fontFamily: 'Nunito',
            fontSize: '20px',
            color: '#0a0e51',
            fontWeight: 'Bold',
            marginLeft: '10px'
        },
        "& h8": {
            fontFamily: 'Nunito',
            fontSize: '16px',
            color: '#0a0e51',
            fontWeight: 'Bold',
            marginLeft: '10px'
        },
        "& #terms_condition": {
            marginLeft: "10%"
        }
    },
    info: {
        margin: "2.5%",
        borderRadius: "7.5px",
        backgroundColor: "#fff3d5",
        paddingBottom: "10px",
        "& h7": {
            fontFamily: "Nunito",
            fontSize: "8px",
            color: "#0a0e51",
            fontWeight: "Bold",
            marginLeft: "20px",
        },
        "& p": {
            fontFamily: "Nunito",
            fontSize: "10px",
            color: "#0a0e51",
            marginLeft: "20px",
        },
    }
});

export default function MuthootFormComponent(props) {
    const [discountedprice, setDiscountedprice] = useState(null);
    const [couponApplied, setCouponApplied] = useState(false);
    const [discount, setDiscount] = useState(null);
    const [discounttext, setDiscounttext] = useState("null");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [payLater, setIsPayLater] = useState(false);
    const isValidate = props.selectedPackage?.isValidate === true;
    const [validated, setValidated] = useState(!isValidate);
    const [formPage, setFormPage] = useState(isValidate ? 0 : 1);

    useEffect(() => {
        if (props.onFormPageChange) {
            props.onFormPageChange(formPage);
        }
    }, [formPage]);

    const showSubmitOnly = localStorage.getItem('showSubmitOnly') === 'true';
    const classes = useStyles();
    const tncData = useDataStore((state) => state.data) || {};
    // Note: benefitToCouponMap in package config is not used by the frontend — backend-only field
    const [isChecked, setIsChecked] = useState(false);
    const [checkboxes, setCheckboxes] = useState(
        tncData.additionalCheckboxes ? tncData.additionalCheckboxes.map(() => false) : []
    );

    const handleCheckbox = (event) => {
        setIsChecked(event.target.checked);
    };
    const handleCheckboxChange = (index) => {
        const updatedCheckboxes = [...checkboxes];
        updatedCheckboxes[index] = !updatedCheckboxes[index];
        setCheckboxes(updatedCheckboxes);
    };
    const allChecked = checkboxes.every(checked => checked);

    let members = Number(getMembers(props.selectedPackage, props.subId)) || 0;
    let price = getPrice(props.selectedPackage, props.subId);
    let strikePrice = props.selectedPackage.showStrikePriceInCheckoutButton && props.selectedPackage.strikePrice || '';
    let payText = props.selectedPackage.checkOutPayButtonText || "Pay ₹ ";
    // hideAdditionMemberDetails is redundant if formPages is configured — just omit "members" from formPages[].sections
    let showAdditionalMemberDetails = !props.selectedPackage.hideAdditionMemberDetails;
    const activeFormPages = buildFormPages(props.selectedPackage, members, showAdditionalMemberDetails);
    const formPageCount = activeFormPages.length;
    const hasMultipleFormPages = formPageCount > 1;
    const isLastFormPage = formPage === formPageCount;
    const currentPageDef = formPage >= 1 && formPage <= formPageCount ? activeFormPages[formPage - 1] : null;
    const currentPageSections = currentPageDef ? (currentPageDef.sections || []) : [];
    const currentPageHasMembers = currentPageSections.includes('members');

    useEffect(() => {
        if (!hasMultipleFormPages) return;
        const handlePopState = () => {
            if (formPage > 1) {
                setFormPage(prev => Math.max(1, prev - 1));
            }
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [formPage, hasMultipleFormPages]);

    const validate = (fieldValues = values) => {
        let temp = { ...errors };
        const formConfig = props.selectedPackage.form || [];
        const allVals = (fieldValues == values) ? values : { ...values, ...fieldValues };
        const validatedKeys = [];
        formConfig.forEach(field => {
            if (currentPageSections.length > 0 && field.section && !currentPageSections.includes(field.section)) return;
            const key = getFieldKey(field);
            validatedKeys.push(key);
            if (key in fieldValues || fieldValues == values) {
                const isOptional = field.isOptional === true;
                const val = allVals[key];
                const activeRule = getActiveConditionalRule(field, allVals);
                const effectivePattern = (activeRule && activeRule.pattern) || field.pattern;
                const effectiveMaxLength = (activeRule && activeRule.maxLength) || field.maxLength;
                const effectiveOptional = (activeRule && activeRule.isOptional !== undefined) ? (activeRule.isOptional === true) : isOptional;
                if (!effectiveOptional) {
                    if (field.type === 'date') {
                        if (!val) temp[key] = `${field.label} is required`;
                        else temp[key] = '';
                    } else if (!val || (typeof val === 'string' && val.trim() === '')) {
                        temp[key] = `${field.label} is required`;
                    } else if (!effectivePattern) {
                        temp[key] = '';
                    }
                }
                if (effectivePattern && val && (!effectiveOptional || (typeof val === 'string' && val.trim() !== ''))) {
                    const regex = new RegExp(effectivePattern);
                    if (!regex.test(val)) {
                        if (effectiveMaxLength && val.length < effectiveMaxLength) {
                            temp[key] = `${field.label} must be ${effectiveMaxLength} characters`;
                        } else {
                            temp[key] = `${field.label} is not valid`;
                        }
                    } else {
                        temp[key] = '';
                    }
                }
                if (effectiveMaxLength && val && val.length > effectiveMaxLength) {
                    temp[key] = `${field.label} should not exceed ${effectiveMaxLength} characters`;
                }
                if (field.type === 'date' && val) {
                    const minAge = field.minAge !== undefined ? field.minAge : 18;
                    const maxAge = field.maxAge !== undefined ? field.maxAge : 75;
                    const age = calculateAge(val);
                    if (age < minAge || age > maxAge) {
                        temp[key] = `Age should be greater than ${minAge} and less than ${maxAge}`;
                    } else {
                        temp[key] = '';
                    }
                }
            }
        });
        if (currentPageHasMembers && showAdditionalMemberDetails && members > 1) {
            for (let i = 2; i <= members; i++) {
                for (const field of memberFormConfig) {
                    const key = `member_${getFieldKey(field)}${i}`;
                    validatedKeys.push(key);
                    if (!(key in fieldValues) && fieldValues != values) continue;
                    const isOptional = field.isOptional === true;
                    const val = allVals[key];
                    if (!isOptional) {
                        if (field.type === 'date') {
                            if (!val) temp[key] = `${field.label} is required`;
                            else temp[key] = '';
                        } else if (!val || (typeof val === 'string' && val.trim() === '')) {
                            temp[key] = `${field.label} is required`;
                        } else if (!field.pattern) {
                            temp[key] = '';
                        }
                    }
                    if (field.pattern && val && (!isOptional || (typeof val === 'string' && val.trim() !== ''))) {
                        const regex = new RegExp(field.pattern);
                        if (!regex.test(val)) {
                            if (field.maxLength && val.length < field.maxLength) {
                                temp[key] = `${field.label} must be ${field.maxLength} characters`;
                            } else {
                                temp[key] = `${field.label} is not valid`;
                            }
                        } else {
                            temp[key] = '';
                        }
                    }
                    if (field.maxLength && val && val.length > field.maxLength) {
                        temp[key] = `${field.label} should not exceed ${field.maxLength} characters`;
                    }
                }
            }
        }
        setErrors({ ...temp });
        if (fieldValues == values)
            return validatedKeys.every(k => !temp[k]);
    };

    const memberCount = Number(getMembers(props.selectedPackage, props.subId)) || 0;
    const memberFormConfig = getMemberFormConfig(props.selectedPackage);
    const dynamicInitialValues = buildInitialValues(props.selectedPackage.form, memberCount, memberFormConfig);
    const initialValues = props.prefillData
        ? { ...dynamicInitialValues, ...props.prefillData }
        : { ...dynamicInitialValues };

    const prefillGender = props.prefillData && props.prefillData.gender;
    const isValidGender = prefillGender === 'Male' || prefillGender === 'Female';
    initialValues.gender = isValidGender ? prefillGender : 'Male';

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialValues, true, validate, {});

    useEffect(() => {
        setFormPage(isValidate ? 0 : 1);
        setValidated(!isValidate);
        setValues(initialValues);
        setErrors({});
    }, [props.selectedPackage?.id, props.subId]);

    useEffect(() => {
        if (props.prefillData) {
            setValues(prev => ({ ...prev, ...props.prefillData }));
        }
    }, [props.prefillData]);

    const isFormValid = () => {
        const formConfig = props.selectedPackage.form || [];
        const allVals = { ...values };
        for (const field of formConfig) {
            if (currentPageSections.length > 0 && field.section && !currentPageSections.includes(field.section)) continue;
            const key = getFieldKey(field);
            const activeRule = getActiveConditionalRule(field, allVals);
            const isOptional = (activeRule && activeRule.isOptional !== undefined) ? (activeRule.isOptional === true) : (field.isOptional === true);
            const val = allVals[key];
            if (!isOptional) {
                if (field.type === 'date') {
                    if (!val) { console.log('isFormValid FAIL: required date field empty:', key, '=>', val); return false; }
                } else if (!val || (typeof val === 'string' && val.trim() === '')) {
                    console.log('isFormValid FAIL: required field empty:', key, '=>', val); return false; }
            }
            const effectivePattern = (activeRule && activeRule.pattern) || field.pattern;
            if (effectivePattern && val && (!isOptional || (typeof val === 'string' && val.trim() !== ''))) {
                if (!new RegExp(effectivePattern).test(val)) { console.log('isFormValid FAIL: pattern mismatch:', key, '=>', val, 'pattern:', effectivePattern); return false; }
            }
            const effectiveMaxLength = (activeRule && activeRule.maxLength) || field.maxLength;
            if (effectiveMaxLength && val && val.length > effectiveMaxLength) { console.log('isFormValid FAIL: maxLength exceeded:', key, '=>', val, 'max:', effectiveMaxLength); return false; }
        }
        if (currentPageHasMembers && showAdditionalMemberDetails && members > 1) {
            for (let i = 2; i <= members; i++) {
                for (const field of memberFormConfig) {
                    const key = `member_${getFieldKey(field)}${i}`;
                    const val = allVals[key];
                    const isOptional = field.isOptional === true;
                    if (!isOptional) {
                        if (field.type === 'date') {
                            if (!val) { console.log('isFormValid FAIL: member date empty:', key); return false; }
                        } else if (!val || (typeof val === 'string' && val.trim() === '')) {
                            console.log('isFormValid FAIL: member field empty:', key); return false; }
                    }
                    if (field.pattern && val && (!isOptional || (typeof val === 'string' && val.trim() !== ''))) {
                        if (!new RegExp(field.pattern).test(val)) { console.log('isFormValid FAIL: member pattern:', key, '=>', val); return false; }
                    }
                    if (field.maxLength && val && val.length > field.maxLength) { console.log('isFormValid FAIL: member maxLength:', key); return false; }
                }
            }
        }
        return true;
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        let trackingId = JSON.parse(sessionStorage.getItem("trackingid"));
        let itemUniqueId = JSON.parse(sessionStorage.getItem("itemuniqueid"));
        if (validate()) {
            setIsSubmitting(true);
            initializeCleverTap();
            var cleverTapUser = {
                "Site": {
                    "Identity": values.email,
                    "Name": values.name,
                    "Phone": "+91".concat(values.mobile),
                    "Email": values.email,
                    "MSG-whatsapp": true
                }
            };
            pushProfileToCleverTap(cleverTapUser);

            const packageId = props.subId ? props.subId : props.selectedPackage.id;
            const metaData = getMetaData(props.selectedPackage, values);
            let form_data = {
                packageId: packageId,
                PackageName: props.PackageName,
                username: values.name,
                email: values.email,
                phonenumber: values.mobile,
                city: values.city,
                pincode: values.pincode,
                address: values.Address || values.addLine1,
                walletAmount: props.selectedPackage.walletAmount,
                price: price
            };
            gtag("event", "payment_initiated", form_data);
            form_data.source = localStorage.getItem("source");
            pushEventToCleverTap("Affinity Payment Initiated", form_data);

            if (price == 0) {
                const memberFieldKeys = memberFormConfig.map(field => ({ key: getFieldKey(field), type: field.type }));
                const freeBeneficiaryData = {};
                for (let i = 2; i <= members; i++) {
                    const memberData = {};
                    let hasAnyValue = false;
                    memberFieldKeys.forEach(({ key, type }) => {
                        const valueKey = `member_${key}${i}`;
                        if (values[valueKey] !== undefined && values[valueKey] !== null && values[valueKey] !== '') {
                            memberData[key] = type === 'date' ? dobConversion(values[valueKey]) : values[valueKey];
                            hasAnyValue = true;
                        }
                    });
                    if (hasAnyValue) {
                        freeBeneficiaryData[`additionalMember${i - 1}`] = memberData;
                    }
                }
                if (metaData) freeBeneficiaryData['metaData'] = metaData;
                try {
                    await addUser(packageId, props.PackageName, price, values, props.selectedPackage.master_policy_no,
                        props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, props.baseURl, freeBeneficiaryData);
                } finally {
                    setIsSubmitting(false);
                }
            } else if (tncData.isCouponCodeFlow || payLater || showSubmitOnly) {
                try {
                    const result = await addAffinityUserDetails(packageId, props.PackageName, price, values, props.selectedPackage.master_policy_no,
                        props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, metaData, tncData.isCouponCodeFlow, payLater, null, trackingId, itemUniqueId, setValues, setDiscountedprice, setDiscounttext, memberFormConfig);
                    if (result && result.success != 0) {
                        if (payLater) setShowSuccessMessage(true);
                        setTimeout(() => {
                            window.location.replace((props.baseURl ? props.baseURl : '/home') + '?utm_source=' + localStorage.getItem("source"));
                        }, 3000);
                    } else {
                        setIsSubmitting(false);
                    }
                } catch (err) {
                    console.error('Submit error:', err);
                    setIsSubmitting(false);
                }
            } else if (props.selectedPackage.isDiscountedFlow && discountedprice && trackingId && itemUniqueId) {
                try {
                    await displayRazorpay(packageId, props.selectedPackage.title, price, values, props.selectedPackage.master_policy_no,
                        props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, metaData, tncData.isCouponCodeFlow, payLater, props.baseURl, trackingId, itemUniqueId, discountedprice, setValues, setDiscountedprice, setDiscounttext, memberFormConfig);
                } finally {
                    setIsSubmitting(false);
                }
            } else {
                try {
                    await displayRazorpay(packageId, props.selectedPackage.title, price, values, props.selectedPackage.master_policy_no,
                        props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, metaData, tncData.isCouponCodeFlow, payLater, props.baseURl, trackingId, itemUniqueId, null, setValues, setDiscountedprice, setDiscounttext, memberFormConfig);
                } finally {
                    setIsSubmitting(false);
                }
            }
        }
    };

    const generateCoupon = () => {
        const labels = "discountcoupon";
        const valueOfElement = "discountcoupon";
        return (
            <>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    marginLeft: "60px",
                    marginRight: "40px",
                }}>
                    <Controls.Input
                        label={labels}
                        name={valueOfElement}
                        onChange={handleInputChange}
                        error={errors[valueOfElement]}
                        value={values.discountcoupon}
                    />
                    <Couponbutton
                        variant="contained"
                        color="primary"
                        size="large"
                        style={{
                            width: "120px",
                            height: "55px",
                            marginRight: "20px"
                        }}
                        onClick={handleCoupon}
                    >
                        Validate
                    </Couponbutton>
                </div>
                {discounttext === "valid"
                    ? couponreactcode()
                    : discounttext === "invalid"
                        ? couponreactinvalid()
                        : (
                            <Grid item container justifyContent="center" style={{ marginTop: '7px', minHeight: '10px' }}>
                                <Typography variant="h6" style={{ fontWeight: "bold" }}>
                                </Typography>
                            </Grid>
                        )
                }
            </>
        );
    };

    const couponreactcode = () => {
        return (
            <Grid item container justifyContent="center" style={{ marginTop: '7px', minHeight: '10px' }}>
                <Fade in={couponApplied} timeout={1000}>
                    <Typography variant="h6" style={{ color: "green", fontWeight: "bold" }}>
                        {`Coupon Applied! You get ${discount} off!`}
                    </Typography>
                </Fade>
            </Grid>
        );
    };

    const couponreactinvalid = () => {
        return (
            <Grid item container justifyContent="center" style={{ marginTop: '7px', minHeight: '10px' }}>
                <Fade in={!couponApplied} timeout={1000}>
                    <Typography variant="h6" style={{ color: "red", fontWeight: "bold" }}>
                        Invalid Code
                    </Typography>
                </Fade>
            </Grid>
        );
    };

    const handleCoupon = async () => {
        let data = {
            couponCode: values.discountcoupon,
            pmEntityId: +props.selectedPackage.pmEntityId,
            userId: 205122661,
            userType: "medibuddy",
            items: [
                {
                    productId: props.selectedPackage.id,
                    contractId: 27623,
                    unitPrice: +props.selectedPackage.price,
                    quantity: 1,
                    itemUniqueId: uuidv4()
                }
            ]
        };
        localStorage.setItem("data", JSON.stringify(data));
        try {
            const response = await fetch('https://affinity.medibuddy.in/patientswebapp/affinity/applyCoupon', {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            const resdataapi = await response.json();
            let resdata = resdataapi.data.data;
            let resobject = resdata.messageBody[0];
            sessionStorage.setItem("trackingid", JSON.stringify(resdata.trackingId));
            sessionStorage.setItem("itemuniqueid", JSON.stringify(resdata.messageBody[0].itemUniqueId));
            setDiscountedprice(resobject.totalDiscountedPrice);
            setDiscounttext("valid");
            setCouponApplied(true);
            setDiscount(resobject.unitDiscount);
        } catch (err) {
            setDiscounttext("invalid");
            setDiscountedprice(null);
            setCouponApplied(false);
            setDiscount(null);
            console.log("Error");
        }
    };

    const generateTextBox = (field) => {
        const labels = field.label;
        const valueOfElement = getFieldKey(field);
        const defaultMessageVal = field.defaultMessage || (field.isOptional === false ? 'required' : '');
        const isPrefilled = valueOfElement === 'referralCode' || (props.prefillData && props.prefillData[valueOfElement]);
        const activeRule = getActiveConditionalRule(field, values);
        const effectiveMaxLength = (activeRule && activeRule.maxLength) || field.maxLength;
        const depKey = field.dependsOn ? getFieldKey({ label: field.dependsOn }) : null;
        const depValue = depKey ? values[depKey] : null;
        const isDisabledByDependency = field.disableUntilDependsOnSet && !depValue;
        return (
            <Controls.Input
                label={labels}
                name={valueOfElement}
                onChange={!isPrefilled ? handleInputChange : () => {}}
                error={errors[valueOfElement]}
                defaultMessage={defaultMessageVal}
                value={values[valueOfElement]}
                readOnly={isPrefilled}
                disabled={isDisabledByDependency}
                inputProps={effectiveMaxLength ? { maxLength: effectiveMaxLength } : {}}
                InputProps={{
                    readOnly: isPrefilled,
                    style: isPrefilled ? {
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                    } : {}
                }}
            />
        );
    };

    const generateDobSelector = (field) => {
        const fieldName = getFieldKey(field);
        const isPrefilled = !!props.prefillData?.[fieldName];
        return (
            <Controls.DatePicker
                key={fieldName}
                name={fieldName}
                label={field.label}
                value={values[fieldName] ? new Date(values[fieldName]) : null}
                onChange={!isPrefilled ? handleInputChange : () => {}}
                error={errors[fieldName]}
                readOnly={isPrefilled}
                InputProps={{
                    readOnly: isPrefilled,
                    style: isPrefilled ? {
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                    } : {}
                }}
            />
        );
    };

    const generateGenderSelection = (field) => {
        const fieldName = field ? getFieldKey(field) : 'gender';
        const prefillGender = props.prefillData && props.prefillData[fieldName];
        const isValidGender = prefillGender === 'Male' || prefillGender === 'Female';
        const fieldOptions = field && field.options
            ? field.options.map(opt => ({ id: opt, title: opt }))
            : genderItems;
        const fieldLabel = field ? field.label : 'Please select your gender';
        return (
            <Controls.RadioGroup
                name={fieldName}
                label={fieldLabel}
                value={values[fieldName]}
                onChange={!isValidGender ? handleInputChange : undefined}
                items={fieldOptions}
                disabled={isValidGender}
                error={errors[fieldName]}
            />
        );
    };

    const generateSelectField = (field) => {
        const fieldName = getFieldKey(field);
        const isPrefilled = props.prefillData && props.prefillData[fieldName] !== undefined;
        const selectOptions = (field.options || []).map(opt =>
            typeof opt === 'string' ? { id: opt, title: opt } : opt
        );
        const handleSelectChange = (e) => {
            if (isPrefilled) return;
            handleInputChange(e);
            const formConfig = props.selectedPackage.form || [];
            formConfig.forEach(f => {
                if (f.dependsOn === field.label) {
                    const depKey = getFieldKey(f);
                    if (values[depKey]) {
                        setValues(prev => ({ ...prev, [depKey]: '' }));
                        setErrors(prev => ({ ...prev, [depKey]: '' }));
                    }
                }
            });
        };
        return (
            <Controls.Select
                name={fieldName}
                label={field.label}
                value={values[fieldName] || ''}
                onChange={handleSelectChange}
                options={selectOptions}
                error={errors[fieldName]}
                defaultMessage={field.defaultMessage || (field.isOptional === false ? 'required' : '')}
            />
        );
    };

    const relationshipOptions = [
        { id: 'Spouse', title: 'Spouse' },
        { id: 'Son', title: 'Son' },
        { id: 'Daughter', title: 'Daughter' },
        { id: 'Father', title: 'Father' },
        { id: 'Mother', title: 'Mother' },
        { id: 'Sibling', title: 'Sibling' },
        { id: 'Other', title: 'Other' }
    ];

    const memberDetailForm = (memberNum) => {
        return (
            <div key={`member-block-${memberNum}`} style={{ width: "100%", marginBottom: "24px" }}>
                <div className="member-section-heading">
                    Member {memberNum}
                </div>
                <Grid container spacing={1} className="member-form-grid">
                    {memberFormConfig.map(field => {
                        const fieldKey = getFieldKey(field);
                        const name = `member_${fieldKey}${memberNum}`;
                        const val = values[name];
                        const isPrefilled = props.prefillData && props.prefillData[name];
                        return (
                            <Grid item xs={12} sm={6} key={name}>
                                {field.type === 'date' ? (
                                    <Controls.DatePicker
                                        name={name}
                                        label={field.label}
                                        value={val ? new Date(val) : null}
                                        onChange={handleInputChange}
                                        error={errors[name]}
                                    />
                                ) : field.type === 'radio' ? (
                                    <Controls.RadioGroup
                                        name={name}
                                        label={field.label}
                                        value={val || (field.options && field.options[0]) || ''}
                                        onChange={handleInputChange}
                                        items={(field.options || []).map(opt => ({ id: opt, title: opt }))}
                                        error={errors[name]}
                                    />
                                ) : field.type === 'select' ? (
                                    <Controls.Select
                                        name={name}
                                        label={field.label}
                                        value={val || ''}
                                        onChange={handleInputChange}
                                        options={(field.options || []).map(opt => ({ id: opt, title: opt }))}
                                        error={errors[name]}
                                        defaultMessage={field.defaultMessage || (field.isOptional === false ? 'required' : '')}
                                    />
                                ) : (
                                    <Controls.Input
                                        label={field.label}
                                        name={name}
                                        value={val || ''}
                                        onChange={handleInputChange}
                                        error={errors[name]}
                                        defaultMessage={field.defaultMessage || (field.isOptional === false ? 'required' : '')}
                                        inputProps={field.maxLength ? { maxLength: field.maxLength } : {}}
                                        readOnly={isPrefilled}
                                    />
                                )}
                            </Grid>
                        );
                    })}
                </Grid>
            </div>
        );
    };

    const createBenForm = (mem) => {
        let table = [];
        for (let i = 2; i <= mem + 1; i++) {
            table.push(memberDetailForm(i));
        }
        return (<>{table}</>);
    };

    const renderSectionFields = (sectionName) => {
        if (sectionName === 'members') return beneficiaryPart();
        if (sectionName === 'coupon') return null;
        let table = [];
        (props.selectedPackage.form || []).forEach(element => {
            if (element.section == sectionName && element.type == 'text') {
                table.push(generateTextBox(element));
            } else if (element.section == sectionName && element.type == 'radio') {
                table.push(generateGenderSelection(element));
            } else if (element.section == sectionName && element.type == 'date') {
                table.push(generateDobSelector(element));
            } else if (element.section == sectionName && element.type == 'select') {
                table.push(generateSelectField(element));
            }
        });
        if (table.length === 0 && sectionName !== 'personal') return null;
        const headerText = sectionName === 'personal' ? 'Personal Details'
            : sectionName === 'address' ? 'Add Address'
            : sectionName.charAt(0).toUpperCase() + sectionName.slice(1);
        return (
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                <Grid item container direction="row" alignItems="center" justifyContent="center">
                    <h8>{headerText}</h8>
                </Grid>
                {table}
            </div>
        );
    };

    const beneficiaryPart = () => {
        if (showAdditionalMemberDetails && members > 1) {
            return (
                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <Grid item container direction="row" alignItems="center" justifyContent="center">
                        <h8>Additional Member Details</h8>
                    </Grid>
                    {createBenForm(members - 1)}
                </div>
            );
        }
    };

    const buttonStyle = window.innerWidth < 768 ? {
        ...props.style,
        width: "60%",
        marginLeft: "20%",
        minHeight: "48px"
    } : props.style;

    const allSteps = [];
    let _stepNum = 1;
    if (isValidate) {
        allSteps.push({ num: _stepNum++, formPage: 0, title: 'Validate' });
    }
    activeFormPages.forEach((page, idx) => {
        allSteps.push({ num: _stepNum++, formPage: idx + 1, title: page.title || `Page ${idx + 1}` });
    });
    const currentStepTitle = allSteps.find(s => s.formPage === formPage)?.title || '';

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container className={`${classes.root} muthoot-form`} spacing={1}>
                <Grid item container direction="row" justifyContent="center" alignItems="center">
                    <CardHeader title={props.selectedPackage.formTitle ? props.selectedPackage.formTitle : "Payment Details"} />
                </Grid>

                {(isValidate || hasMultipleFormPages) && (
                    <Grid item container direction="row" justifyContent="center" alignItems="center">
                        <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "8px" }}>
                            {allSteps.map((step, i) => (
                                <React.Fragment key={step.formPage}>
                                    {i > 0 && (
                                        <div style={{ width: "40px", height: "2px", backgroundColor: formPage > allSteps[i - 1].formPage ? "#4caf50" : "#ccc" }} />
                                    )}
                                    <div style={{
                                        width: "28px", height: "28px", borderRadius: "50%",
                                        backgroundColor: formPage === step.formPage ? "#2e86f3" : (formPage > step.formPage ? "#4caf50" : "#ccc"),
                                        color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
                                        fontSize: "14px", fontWeight: "bold"
                                    }}>{step.num}</div>
                                </React.Fragment>
                            ))}
                            <span style={{ marginLeft: "8px", fontSize: "13px", color: "#0a0e51", fontWeight: "600" }}>
                                {currentStepTitle}
                            </span>
                        </div>
                    </Grid>
                )}

                {isValidate && formPage === 0 && (
                    <Grid item xs={12}>
                        <ValidateMembershipComponent
                            onValidated={() => {
                                setValidated(true);
                                setFormPage(1);
                            }}
                        />
                    </Grid>
                )}

                {(!isValidate || formPage >= 1) && formPage >= 1 && formPage <= formPageCount && currentPageSections.map(sectionName => (
                    <React.Fragment key={sectionName}>
                        {renderSectionFields(sectionName)}
                    </React.Fragment>
                ))}

                {(!isValidate || formPage >= 1) && formPage >= 1 && formPage <= formPageCount && currentPageSections.includes('coupon') && props.selectedPackage.isDiscountedFlow ? generateCoupon() : ''}

                {(!isValidate || formPage >= 1) && isLastFormPage && tncData.additionalCheckboxes && tncData.additionalCheckboxes.length > 0 && tncData.additionalCheckboxes.map((checkbox, index) => {
                    return (
                        <Grid key={index} item direction="row" id='terms_condition' style={{ display: 'flex', alignItems: 'center' }}>
                            <input name={`checkbox${index}`} type='checkbox' checked={checkboxes[index]} onChange={() => handleCheckboxChange(index)}></input>
                            <h8 dangerouslySetInnerHTML={{ __html: (checkbox.textInput1 || '').replace(/&#60;/g, "<").replace(/&#62;/g, ">") }} />
                        </Grid>
                    );
                })}

                {(!isValidate || formPage >= 1) && isLastFormPage && tncData.tncAbovePayButton ? (
                    <Grid item container direction="row" alignItems="left" justifyContent="left" id='terms_condition'>
                        {tncData.showTnCcheckbox ? <input name='checkbox' type='checkbox' onChange={handleCheckbox} checked={isChecked}></input> : ''}
                        <h8>By proceeding to pay, you agree to our <a href={"/terms-and-conditions?utm_source=" + localStorage.getItem('source')} target={'_blank'}>Terms & Conditions</a></h8>
                    </Grid>
                ) : ''}

                {formPage !== 0 && (
                <div style={{ width: "100%", maxWidth: "480px", margin: "2% auto", textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
                    {hasMultipleFormPages && !isLastFormPage ? (
                        <Controls.Button
                            type="button"
                            text="Next"
                            onClick={() => {
                                if (validate()) {
                                    window.history.pushState({ formPage: formPage + 1 }, '');
                                    setFormPage(formPage + 1);
                                }
                            }}
                            disabled={isSubmitting || (tncData.showTnCcheckbox && !isChecked) || (tncData.additionalCheckboxes && tncData.additionalCheckboxes.length > 0 && !allChecked)}
                            style={buttonStyle}
                        />
                    ) : hasMultipleFormPages && isLastFormPage ? (
                        <>
                            <Controls.Button
                                type="button"
                                text="Back"
                                onClick={() => window.history.back()}
                                disabled={isSubmitting}
                                style={{
                                    width: "35%",
                                    minHeight: "48px",
                                    marginLeft: "0",
                                    marginRight: "0",
                                    backgroundColor: "#f5f5f5",
                                    color: "#0a0e51",
                                    border: "1px solid #ccc"
                                }}
                            />
                            <Controls.Button
                                type="submit"
                                text={currentPageHasMembers ? "Skip & Pay" : ((tncData.isCouponCodeFlow || showSubmitOnly) ? "Submit" : (discountedprice ? discountedprice : price))}
                                prefix={currentPageHasMembers || (tncData.isCouponCodeFlow || showSubmitOnly) ? '' : payText}
                                strikeText={currentPageHasMembers || (tncData.isCouponCodeFlow || showSubmitOnly) ? '' : (discountedprice ? price : (strikePrice ? strikePrice : ''))}
                                disabled={isSubmitting || (tncData.showTnCcheckbox && !isChecked) || (tncData.additionalCheckboxes && tncData.additionalCheckboxes.length > 0 && !allChecked)}
                                style={{
                                    width: "35%",
                                    minHeight: "48px",
                                    marginLeft: "0",
                                    marginRight: "0",
                                    backgroundColor: "#2e86f3",
                                    color: "#fff"
                                }}
                            />
                        </>
                    ) : (
                        <Controls.Button
                            type="submit"
                            style={buttonStyle}
                            text={(tncData.isCouponCodeFlow || showSubmitOnly) ? "Submit" : (discountedprice ? discountedprice : price)}
                            prefix={(tncData.isCouponCodeFlow || showSubmitOnly) ? '' : payText}
                            strikeText={(tncData.isCouponCodeFlow || showSubmitOnly) ? '' : (discountedprice ? price : (strikePrice ? strikePrice : ''))}
                            disabled={isSubmitting || (tncData.showTnCcheckbox && !isChecked) || (tncData.additionalCheckboxes && tncData.additionalCheckboxes.length > 0 && !allChecked)}
                        />
                    )}
                    <div style={{ textAlign: 'center', width: '100%' }}>
                        {props.selectedPackage.priceWithGST && (
                            <i style={{ fontSize: '10px' }}>*inclusive of GST</i>)}
                    </div>
                </div>
                )}

                {showSuccessMessage && (
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                        <div style={{
                            backgroundColor: '#e8f5e9',
                            color: '#2e7d32',
                            padding: '15px',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <CheckCircleOutlineIcon style={{ color: '#2e7d32' }} />
                            <div>
                                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Payment Link Sent Successfully!</Typography>
                                <Typography variant="body2">We've sent a payment link to {values.mobile}</Typography>
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid>
        </Form>
    );
}
